import { render, staticRenderFns } from "./FloorplanSample.vue?vue&type=template&id=8ddf3066&"
import script from "./FloorplanSample.vue?vue&type=script&lang=ts&"
export * from "./FloorplanSample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports